import ErrorBoundary from "./ErrorBoundary";
export { captureError, isChunkLoadError } from "./ErrorBoundary";
export default ErrorBoundary;
